var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCssLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1800pt",
    height: "1799.999925pt",
    viewBox: "0 0 1800 1799.999925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 255.601562 180 L 1543.808594 180 L 1543.808594 1620 L 255.601562 1620 Z M 255.601562 180 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.779724%,46.669006%,74.119568%)",
      fillOpacity: 1
    },
    d: "M 1543.621094 180 L 255.785156 180 L 369.417969 1468.421875 L 899.703125 1620 L 1429.988281 1468.421875 Z M 1543.621094 180 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.179504%,60.778809%,89.7995%)",
      fillOpacity: 1
    },
    d: "M 899.703125 293.683594 L 899.703125 1502.527344 L 1323.929688 1381.261719 L 1418.625 293.683594 Z M 899.703125 293.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1244.390625 483.15625 L 899.703125 483.15625 L 899.703125 634.738281 L 1085.304688 634.738281 L 1073.941406 786.316406 L 899.703125 786.316406 L 899.703125 937.894531 L 1066.363281 937.894531 L 1055 1108.421875 L 899.703125 1161.472656 L 899.703125 1320.632812 L 1198.9375 1222.105469 L 1225.449219 786.316406 Z M 1244.390625 483.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.328857%,93.328857%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 899.703125 483.15625 L 899.703125 634.738281 L 562.59375 634.738281 L 551.230469 483.15625 Z M 725.46875 786.316406 L 733.042969 937.894531 L 899.703125 937.894531 L 899.703125 786.316406 Z M 740.617188 1013.683594 L 589.109375 1013.683594 L 600.472656 1222.105469 L 899.703125 1320.632812 L 899.703125 1161.472656 L 744.40625 1108.421875 Z M 740.617188 1013.683594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssLogo);
export default __webpack_public_path__ + "static/media/CssLogo.ecd060fb83deb25fcded9c136d81127c.svg";
export { ForwardRef as ReactComponent };